import intlTelInput from "intl-tel-input";
import "intl-tel-input/styles";

/**
 * https://github.com/jackocnr/intl-tel-input?tab=readme-ov-file#react-and-vue-components
 *
 */

export const useIntlTelInput = () => {
    /**
     * Create an intl-tel-input component on top of an existing input
     *
     * @param {HTMLInputElement} input where to place the component
     * @param {string} country 2 letters country name, in lowercase.
     * @returns {IntlTelInput} instance
     * @example
     * ```html
     *  <input x-init="IntlTelInput.transform($el)">
     *  <!-- or with livewire -->
     *  <x-forms.input
            type="text"
            field="form.phone"
            x-ref="phoneInput"
            x-init="IntlTelInput.transform($el, 'gb');"
            label="Phone"
            class="form-inverted"
        />
     *  ```
        Adding phone_hidden through livewire
        ```html
        <form  @submit.prevent="$wire.form.phone_hidden = $ref.phoneInput.getNumber(); $wire._your_submit_action_();">
            <x-forms.input
                type="hidden"
                field="form.phone_hidden"
                x-ref="phoneHidden"
            />
        </form>
     *  ```
     */
    const transform = (input, country) => {
        const onlyCountries = window.appContext?.Brand?.countries ?? [];

        return intlTelInput(input, {
            countrySearch: true,
            numberDisplayFormat: 'INTERNATIONAL',
            initialCountry: country ? String(country).toLowerCase() : undefined,
            onlyCountries,
            separateDialCode: true,

            loadUtils: () => import("intl-tel-input/utils"),
        });
    };

    return { transform };
};
